import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MButton } from '@/components/ui/atoms/MButtons';
import MaatraLogo from '@/components/ui/atoms/MaatraLogo';
import styles from './SignupLanding.module.css';
import { getPreferredLoginMethod } from '@/utils/storage-utils';

const SignupLanding: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const preferredMethod = getPreferredLoginMethod() || 'mobile';

  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <div className={styles.watermark}>
          <MaatraLogo fill='#e9e3f5' size={400} />
        </div>
        <div className={styles.logoCircleWrapper}>
          <div className={styles.logoCircleInner}>
            <MaatraLogo fill='#fff' size={45}/>
          </div>
        </div>
      </div>

      <div className={styles.bottomSection}>
        <div>
          <h1 className={styles.title}>
            {t('auth.signupLanding.title').split('\n').map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i < t('auth.signupLanding.title').split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </h1>
          <p className={styles.subtitle}>
            {t('auth.signupLanding.subtitle').split('\n').map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i < t('auth.signupLanding.subtitle').split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        </div>

        {/* Buttons */}
        <div className={styles.buttonContainer}>
          <MButton
            variant="filled"
            size="lg"
            onClick={() => navigate('/login/form', { state: { mode: preferredMethod, isLogin: true } })}
          >
            {t('auth.signupLanding.loginButton')}
          </MButton>
          <MButton
            variant="link"
            size="lg"
            className="text-[#4C189A]"
            onClick={() => navigate('/register/info')}
          >
            {t('auth.signupLanding.signupButton')}
          </MButton>
        </div>
      </div>
    </div>
  );
};

export default SignupLanding;
